import { create } from 'zustand';
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import { persist } from 'zustand/middleware';

export const useEnvelopesStore = create()(
    persist(
        (set) => ({
            refetchEnvelopes: false,
            storeRefetchEnvelopes: (refetchEnvelopes) => set(() => ({ refetchEnvelopes: refetchEnvelopes })),
            queryEnvelopes: getInitialQuery(),
            storeQueryEnvelopes: (query) => set(() => ({ queryEnvelopes: query })),

            refetchDownloadCodes: false,
            storeRefetchDownloadCodes: (refetchDownloadCodes) => set(() => ({ refetchDownloadCodes: refetchDownloadCodes })),
            queryDownloadCodes: getInitialQuery(),
            storeQueryDownloadCodes: (query) => set(() => ({ queryDownloadCodes: query }))
        }),
        {
            name: 'envelopes-storage'
        }
    )
);

export default useEnvelopesStore;